import React from "react";

// tslint:disable: max-line-length
interface Props {
  width?: number;
  height?: number;
}
export default function Accueil(props: Props) {
  return (
    <svg
      width={props.width ? props.width + "px" : "26px"}
      height={props.height ? props.height + "px" : "26px"}
      viewBox="0 0 24 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Accueil</title>
      <g
        id="BOARD-3---Icônes"
        transform="translate(-637.000000, -385.000000)"
        fill="#1B202D"
      >
        <g id="Pictogrammes" transform="translate(305.000000, 178.000000)">
          <g id="14---Accueil" transform="translate(332.000000, 204.000000)">
            <path
              d="M15.5747843,27.722496 L22.7478216,27.722496 L22.7478216,13.9281148 L12.0002608,4.48150537 L1.25165692,13.9281148 L1.25165692,27.722496 L8.42521567,27.722496 L8.42521567,19.9946617 C8.42521567,19.6417512 8.70579543,19.3559097 9.05104413,19.3559097 L14.9489559,19.3559097 C15.2942046,19.3559097 15.5747843,19.6417512 15.5747843,19.9946617 L15.5747843,27.722496 Z M23.3741715,29 L14.9489559,29 C14.6031856,29 14.3231274,28.7141585 14.3231274,28.361248 L14.3231274,20.6334137 L9.6768726,20.6334137 L9.6768726,28.361248 C9.6768726,28.7141585 9.39681436,29 9.05104413,29 L0.625828462,29 C0.280058237,29 0,28.7141585 0,28.361248 L0,13.6353535 C0,13.4495831 0.0792716052,13.2728617 0.217475391,13.1509666 L11.5913862,3.15449813 C11.8265934,2.94850062 12.1739282,2.94850062 12.4086138,3.15449813 L23.7825246,13.1509666 C23.9202069,13.2728617 24,13.4495831 24,13.6353535 L24,28.361248 C24,28.7141585 23.7194202,29 23.3741715,29 L23.3741715,29 Z"
              id="icon"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
